const a = (t, e, n) => new Date(Date.UTC(t, e, n)), s = () => {
  const t = /* @__PURE__ */ new Date();
  return a(t.getFullYear(), t.getMonth(), t.getDate());
}, g = (t) => a(t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate()), c = (t) => a(t.getUTCFullYear(), t.getUTCMonth(), 1), T = (t) => a(t.getUTCFullYear(), t.getUTCMonth() + 1, 0), C = (t) => Math.floor(t.getUTCMonth() / 3) + 1, D = (t) => a(t.getUTCFullYear(), (C(t) - 1) * 3, 1), h = (t, e) => (e.getUTCFullYear() - t.getUTCFullYear()) * 12 + e.getUTCMonth() - t.getUTCMonth(), r = (t, e) => a(t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate() + e), M = (t, e) => a(t.getUTCFullYear(), t.getUTCMonth() + e, 1), l = (t) => (t.getUTCDay() + 6) % 7, u = (t) => r(g(t), -l(t)), o = (t) => {
  const e = String(t.getUTCMonth() + 1).padStart(2, "0"), n = String(t.getUTCDate()).padStart(2, "0");
  return `${t.getUTCFullYear()}-${e}-${n}`;
}, y = (t) => {
  const [e, n, U] = t.split("-").map(Number);
  return a(e, n - 1, U);
}, i = (t) => {
  const e = a(
    t.getUTCFullYear(),
    t.getUTCMonth(),
    t.getUTCDate()
  );
  e.setUTCDate(
    e.getUTCDate() - (e.getUTCDay() + 6) % 7 + 3
  );
  const n = a(e.getUTCFullYear(), 0, 4);
  return n.setUTCDate(
    n.getUTCDate() - (n.getUTCDay() + 6) % 7 + 3
  ), 1 + Math.round(
    (e.getTime() - n.getTime()) / 6048e5
  );
}, F = (t, e = s()) => {
  const n = r(e, -1);
  return {
    startDate: o(r(n, -(t - 1))),
    endDate: o(n)
  };
}, Y = (t = s()) => {
  const e = r(t, -1);
  return {
    startDate: o(a(e.getUTCFullYear(), 0, 1)),
    endDate: o(e)
  };
}, d = (t = s()) => {
  const e = u(t);
  return {
    startDate: o(e),
    endDate: o(r(e, 6))
  };
}, f = (t = s()) => ({
  startDate: o(c(t)),
  endDate: o(T(t))
});
export {
  r as addDaysUtc,
  M as addMonthsUtc,
  T as endOfMonthUtc,
  y as isoToUtc,
  i as isoWeekNumber,
  h as monthsBetweenUtc,
  C as quarterOfUtc,
  F as rollingWindowRange,
  g as startOfDayUtc,
  c as startOfMonthUtc,
  D as startOfQuarterUtc,
  u as startOfWeekUtc,
  f as thisMonthRange,
  d as thisWeekRange,
  o as toIsoDate,
  s as todayUtc,
  a as utcDate,
  Y as yearToDateRange
};
//# sourceMappingURL=dates.js.map
